var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconUser = function SvgIconUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.6662V23.5415C0.0803097 21.9638 1.02871 20.5607 2.46271 19.8981C9.225 17.1818 16.775 17.1818 23.5373 19.8981C24.9713 20.5607 25.9197 21.9638 26 23.5415V25.6662C25.9994 26.8164 25.5417 27.9192 24.7276 28.7318C23.9135 29.5443 22.8098 29.9999 21.6596 29.9982H4.34037C3.19018 29.9999 2.0865 29.5443 1.2724 28.7318C0.458297 27.9192 0.000559292 26.8164 0 25.6662ZM13 0.428711C10.0782 0.427857 7.44366 2.18724 6.32495 4.88637C5.20624 7.5855 5.82372 10.6928 7.88943 12.7591C9.95514 14.8254 13.0622 15.4438 15.7617 14.3259C18.4611 13.2079 20.2213 10.5739 20.2213 7.65211C20.2218 5.73654 19.4613 3.89923 18.107 2.54452C16.7527 1.18981 14.9156 0.428711 13 0.428711Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-user.35011986a943bc681ff7e8fdfdbff791.blank.svg";